export class AddProgressBarWorkflowStack {
  static readonly type = '[ProgressBarWorkflow] AddProgressBarWorkflowStack';
  constructor(public payload: { uniqueId: string }) {}
}

export class RemoveProgressBarWorkflowStack {
  static readonly type = '[ProgressBarWorkflow] RemoveProgressBarWorkflowStack';
  constructor(public payload: { uniqueId: string }) {}
}

export class RemoveAllProgressBarWorkflowStack {
  static readonly type = '[ProgressBarWorkflow] RemoveAllProgressBarWorkflowStack';
}
